import { render, staticRenderFns } from "./PageAnnouncements.vue?vue&type=template&id=942efa6c&scoped=true&"
import script from "./PageAnnouncements.vue?vue&type=script&lang=ts&"
export * from "./PageAnnouncements.vue?vue&type=script&lang=ts&"
import style0 from "./PageAnnouncements.vue?vue&type=style&index=0&id=942efa6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942efa6c",
  null
  
)

export default component.exports